import React from 'react';
import { Link } from 'react-router-dom';
import Page from '../components/Layout/Page';

// Mise à jour du 2026-10-22 : plus d'abonnement pour les particuliers. Les
// mentions de paiement et d'abonnement sans objet sont retirées ; Stripe reste
// cité pour les seuls garages partenaires. Ajout du consentement aux emails
// (case non pré-cochée de l'inscription).
const UPDATED = '22 octobre 2026';

const RIGHTS = [
  ["Droit d'accès", 'Obtenir une copie de vos données personnelles traitées par ZENKART.'],
  ['Droit de rectification', 'Corriger vos données inexactes ou incomplètes.'],
  ["Droit à l'effacement", "Demander la suppression de vos données (« droit à l'oubli »)."],
  ['Droit à la limitation', 'Limiter le traitement de vos données dans certains cas.'],
  ['Droit à la portabilité', 'Recevoir vos données dans un format structuré et lisible par machine.'],
  ["Droit d'opposition", 'Vous opposer au traitement de vos données à des fins de prospection.'],
];

const DONNEES = [
  ['Identité', 'Email, pseudo (nom facultatif)', 'Création et gestion du compte'],
  ['Contact', 'Adresse email, Telegram (opt.)', 'Messages liés au compte, alertes Telegram si vous les activez'],
  ['Emails d’information', 'Adresse email, date et texte du consentement',
   'Vous envoyer des alertes et les nouvelles bonnes affaires, uniquement si vous avez coché la case prévue à l’inscription'],
  ['Paiement (garages)', 'Stripe Customer ID (pas de CB)', 'Achat de crédits par les garages partenaires, lorsqu’il est proposé'],
  ['Navigation', 'Annonces consultées, favoris', 'Historique, personnalisation'],
  ['Technique', 'Adresse IP, user-agent', 'Sécurité, lutte contre la fraude'],
  ['Vente de véhicule', 'Prénom, téléphone, email, code postal, description et photos du véhicule',
   'Vous rappeler, puis transmettre votre demande aux garages partenaires (avec votre accord)'],
  ['Recherche de véhicule', 'Critères recherchés (marques, budget, secteur, usage, urgence), prénom, téléphone, email, code postal',
   'Chercher le véhicule pour vous et vous recontacter ; transmission anonyme à des professionnels partenaires si vous l’acceptez'],
];

export default function PolitiqueConfidentialitePage() {
  return (
    <Page largeur="etroite" titre="Politique de confidentialité">
      <div className="zk-texte">
        <p className="zk-texte-date">Dernière mise à jour : {UPDATED} · Conforme au RGPD (UE) 2016/679</p>

        <h2>1. Responsable du traitement</h2>
        <p><strong>FAYEMAKERS</strong> (entreprise individuelle) est le responsable du traitement de vos données personnelles dans le cadre du service ZENKART.</p>
        <p><strong>Contact DPO :</strong> <a href="mailto:privacy@zenkart.fr">privacy@zenkart.fr</a></p>

        <h2>2. Données collectées</h2>
        <p>Nous collectons les données suivantes lors de votre utilisation de ZENKART :</p>
        <div className="zk-tableau">
          <table>
            <thead><tr><th>Catégorie</th><th>Données</th><th>Finalité</th></tr></thead>
            <tbody>
              {DONNEES.map(([cat, data, purpose]) => (
                <tr key={cat}><td><strong>{cat}</strong></td><td>{data}</td><td>{purpose}</td></tr>
              ))}
            </tbody>
          </table>
        </div>
        <p>Les particuliers ne paient rien sur ZENKART. Les paiements éventuels des garages partenaires sont traités exclusivement par Stripe (certifié PCI-DSS niveau 1) : nous ne collectons <strong>jamais</strong> de coordonnées bancaires.</p>

        <h2>3. Bases légales du traitement</h2>
        <ul>
          <li><strong>Exécution du contrat</strong> : traitement des données nécessaires à la fourniture du service (compte, favoris, historique, alertes)</li>
          <li><strong>Intérêt légitime</strong> : sécurité, prévention de la fraude, amélioration du service</li>
          <li><strong>Consentement</strong> : emails d’information (alertes, nouvelles bonnes affaires). La case de l’inscription n’est <strong>pas pré-cochée</strong> ; sans elle, votre email ne sert qu’à votre compte. Vous retirez votre consentement à tout moment par le lien de désinscription de chaque email ou en écrivant à <a href="mailto:privacy@zenkart.fr">privacy@zenkart.fr</a>.</li>
          <li><strong>Obligation légale</strong> : conservation des données de facturation (10 ans)</li>
        </ul>

        <h2>4. Durée de conservation</h2>
        <ul>
          <li><strong>Données de compte</strong> : pendant l’utilisation du compte, puis 3 ans après sa dernière utilisation ou dès sa suppression à votre demande</li>
          <li><strong>Preuve du consentement aux emails</strong> : tant que le consentement court, puis 3 ans après son retrait</li>
          <li><strong>Données de navigation</strong> (historique, favoris) : 12 mois glissants</li>
          <li><strong>Données de facturation</strong> (paiements des garages, et paiements passés des anciennes formules) : 10 ans (obligation légale comptable)</li>
          <li><strong>Logs techniques</strong> : 90 jours</li>
          <li><strong>Demandes de vente de véhicule</strong> : 12 mois après le dernier contact</li>
          <li><strong>Demandes de recherche de véhicule</strong> (« Trouvez ma voiture ») : 12 mois après le dernier contact</li>
        </ul>

        <h2>5. Vos droits RGPD</h2>
        <ul>
          {RIGHTS.map(([droit, desc]) => <li key={droit}><strong>{droit}</strong> : {desc}</li>)}
        </ul>
        <p>Pour exercer vos droits, adressez une demande à <a href="mailto:privacy@zenkart.fr">privacy@zenkart.fr</a>. Nous répondrons dans un délai de 30 jours. Vous avez également le droit d’introduire une réclamation auprès de la <strong>CNIL</strong> (cnil.fr).</p>

        <h2>6. Transferts hors UE</h2>
        <p>Certains sous-traitants (OpenAI, Stripe) peuvent traiter des données hors de l’Union européenne. Ces transferts sont encadrés par des Clauses Contractuelles Types (CCT) approuvées par la Commission européenne.</p>

        <h2>7. Cookies et traceurs</h2>
        <p>ZENKART utilise uniquement les cookies strictement nécessaires au fonctionnement du service : des cookies de session sécurisés (httpOnly) pour l’authentification et un jeton anti-CSRF. Aucun cookie de traçage publicitaire n’est utilisé.</p>
        <p>Vous pouvez supprimer ces cookies à tout moment depuis les paramètres de votre navigateur ; vous serez alors déconnecté.</p>

        <h2>8. Partage de données</h2>
        <p>Vos données ne sont <strong>jamais cédées à des tiers pour de la publicité</strong>. Elles peuvent être partagées uniquement avec :</p>
        <ul>
          <li><strong>Stripe</strong> : traitement des paiements des garages partenaires</li>
          <li><strong>OpenAI</strong> : analyse IA des annonces (données anonymisées)</li>
          <li><strong>Telegram</strong> : envoi d’alertes (si vous activez l’option)</li>
          <li><strong>Garages partenaires</strong> : fiche anonyme d’abord, coordonnées seulement si un garage déverrouille votre demande — et vous en êtes averti (voir ci-dessous)</li>
          <li><strong>Autorités compétentes</strong> : sur réquisition judiciaire</li>
        </ul>

        <h2>8 bis. « Vendre ma voiture » : ce que voient les garages</h2>
        <p>
          Quand vous demandez des offres de rachat, votre demande est d’abord publiée <strong>de façon anonyme</strong>
          auprès des garages partenaires de votre secteur. À ce stade, un garage voit uniquement : la marque, le modèle,
          l’année, le kilométrage, l’état déclaré, vos photos, une estimation, et un <strong>secteur approximatif</strong>
          (« Bordeaux (33) ») accompagné de coordonnées arrondies au kilomètre.
        </p>
        <p>
          <strong>Aucune coordonnée n’est transmise à ce stade</strong> : ni prénom, ni téléphone, ni email, ni code postal
          exact. La description que vous rédigez est automatiquement expurgée des numéros de téléphone, adresses email et
          liens qu’elle pourrait contenir — l’original n’est lisible que par ZENKART.
        </p>
        <p>
          Un garage intéressé <strong>déverrouille</strong> votre demande pour obtenir vos coordonnées, ce qui lui est
          facturé. <strong>Vous en êtes averti par email</strong>, avec le nom du garage, au moment où cela se produit.
        </p>
        <p>
          Chaque garage accepte à son inscription des <Link to="/cgu-garage">conditions</Link> qui lui interdisent de
          réutiliser vos coordonnées au-delà de l’offre de rachat sur ce véhicule, de les revendre, de les céder ou de
          vous démarcher pour autre chose. Un manquement entraîne la suspension de son accès.
        </p>
        <p>
          L’ensemble repose sur votre <strong>consentement explicite</strong>, donné par une case à cocher avant l’envoi :
          sans elle, aucune demande n’est enregistrée.
        </p>
        <p>
          <strong>Notre modèle économique, dit clairement :</strong> ZENKART est rémunéré par les garages pour cette mise
          en relation. Nous vérifions chaque demande à la main avant de la transmettre ; une demande refusée n’est jamais
          communiquée. Vous pouvez retirer votre consentement à tout moment en écrivant à{' '}
          <a href="mailto:privacy@zenkart.fr">privacy@zenkart.fr</a> : votre demande est alors supprimée et n’est plus
          transmise. Les photos que vous envoyez sont réenregistrées sans leurs métadonnées, en particulier sans la
          position GPS de prise de vue.
        </p>

        <h2>8 ter. « Trouvez ma voiture » : ce que nous faisons de votre demande</h2>
        <p>
          Quand vous nous confiez une recherche, nous enregistrons vos <strong>critères</strong> (budget, type de
          voiture, et s’ils sont précisés : marque et modèle, kilométrage, année, énergie, boîte, département) et vos
          <strong> coordonnées</strong> (prénom, téléphone, email, code postal).
        </p>
        <p>
          <strong>Deux consentements distincts</strong>, donnés par deux cases à cocher séparées avant l’envoi :
        </p>
        <ul>
          <li>
            <strong>Le recontact par ZENKART</strong> — obligatoire : sans lui le service n’a pas d’objet, et aucune
            demande n’est enregistrée.
          </li>
          <li>
            <strong>La transmission à des professionnels partenaires</strong> — <strong>facultative</strong>, et refusable
            sans conséquence sur le service. Si vous l’acceptez, un partenaire ne reçoit que la demande
            <strong> sous forme anonyme</strong> : critères, budget et secteur. <strong>Jamais votre prénom, votre
            téléphone, votre email ni votre code postal.</strong>
          </li>
        </ul>
        <p>
          La recherche est faite <strong>à la main</strong> par ZENKART dans sa base d’annonces. Nous ne vous promettons
          pas de trouver : nous nous engageons à chercher et à vous répondre, y compris pour vous dire que rien ne
          correspond. <strong>Aucune proposition ne vous est envoyée automatiquement</strong> ; chacune est vérifiée avant
          de vous être adressée.
        </p>
        <p>
          Vos coordonnées ne servent qu’à cette recherche. Elles sont conservées <strong>12 mois après notre dernier
          échange</strong>, puis supprimées automatiquement. Vous pouvez les faire supprimer à tout moment, ou retirer
          votre consentement à la transmission, en écrivant à{' '}
          <a href="mailto:privacy@zenkart.fr">privacy@zenkart.fr</a>.
        </p>

        <h2>9. Sécurité</h2>
        <p>ZENKART met en œuvre des mesures techniques et organisationnelles appropriées : chiffrement des mots de passe (bcrypt), HTTPS, cookies de session httpOnly, limitation du nombre de requêtes, et accès restreint aux données de production.</p>

        <h2>10. Contact</h2>
        <p>Pour toute question relative à cette politique : <a href="mailto:privacy@zenkart.fr">privacy@zenkart.fr</a></p>
        <p>FAYEMAKERS — Produit ZENKART</p>

        <nav className="zk-texte-liens" aria-label="Documents légaux">
          <Link to="/cgu" className="zk-lien">Conditions d’utilisation</Link>
          <Link to="/mentions-legales" className="zk-lien">Mentions légales</Link>
          <Link to="/explore" className="zk-lien">Voir les bonnes affaires</Link>
        </nav>
      </div>
    </Page>
  );
}
